module.exports = __webpack_public_path__ + "img/mes-hero.e81304d7.jpg";